import { render, staticRenderFns } from "./ApplicationManagement.vue?vue&type=template&id=5d7b7b47&scoped=true"
import script from "./ApplicationManagement.vue?vue&type=script&lang=js"
export * from "./ApplicationManagement.vue?vue&type=script&lang=js"
import style0 from "./ApplicationManagement.vue?vue&type=style&index=0&id=5d7b7b47&prod&scoped=true&lang=css"
import style1 from "./ApplicationManagement.vue?vue&type=style&index=1&id=5d7b7b47&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7b7b47",
  null
  
)

export default component.exports